module.exports = __webpack_public_path__ + "static/media/20_000023.44516698.jpg";